export default __webpack_public_path__ + "static/media/CalEvans.badd9be0.png";